export const SEARCH_HEADER = 'Search results';

export const NO_SEARCH_RESULTS_TEST_ID = 'no-search-results';
